
export interface AirtableDatasourceConfig {
    baseId: string;
    tableId: string;
};

export interface GoogleSheetDatasourceConfig {
    docId: string;
    sheetId: number;
};

export interface APIDatasourceConfig {
    url?: string;
    interface?: "json" | "csv" | "xml";
    method?: "GET" | "POST";
    headers?: string;
    body?: string;
    transform?: string;
};

export interface SnowflakeDatasourceConfig {
    account: string,
    username: string,
    password: string,
    warehouse: string,
    database: string,
    schema: string,

    query: string
}

export interface ClickhouseDatasourceConfig {
    url: string;
    pathname: string;
    username: string;
    password: string;
    database: string;

    query: string;
};

export interface BigQueryDatasourceConfig {
    credentials: string;
    projectId: string;
    location: string;

    query: string;
};

export interface CSVDatasourceConfig {
    url: string;
};

export interface ExcelDatasourceConfig {
    url: string;
    sheetName?: string;
};

export interface FirestoreDatasourceConfig {
    type: string;
    project_id: string;
    private_key_id: string;
    private_key: string;
    client_email: string;
    client_id: string;
    auth_uri: string;
    token_uri: string;
    auth_provider_x509_cert_url: string;
    client_x509_cert_url: string;
    universe_domain: string;
    databaseURL: string;

    collection?: string;
    subcollection?: string;
};
export interface MongoDBDatasourceConfig {
    url: string;
    database: string;

    collection: string;
    query: string;
};

export interface MsSQLDatasourceConfig {
    server: string;
    port: string;
    user: string;
    password: string;
    database: string;

    query: string;
};
export interface ExternalConfig {
    schema: string;
    serviceAccount: string;

    table: string;
    query: string;
};

export interface MySQLDatasourceConfig {
    host: string;
    user: string;
    port: string;
    password: string;
    database: string;
    ssh_enabled?: boolean;
    ssh_host?: string;
    ssh_username?: string;
    ssh_port?: string;
    ssh_private_key?: string;

    query: string;
};


export interface PostgreSQLDatasourceConfig {
    host: string;
    port: string;
    database: string;
    user: string;
    password: string;
    ssl_enabled: boolean;

    query: string;
};


// Add a dummy export to ensure this file is included
export const __ensureFileIsEmitted = true;